import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    redirect: '/home',
    meta: {
      title: '首页',
      renderMenu: false,
      icon: 'CreditCardOutlined'
    }
  },
  {
    path: '/datascreen',
    name: 'datascreen',
    component: () => import('@/pages/dataScreen'),
    meta: {
      renderMenu: false,
      title: '数据大屏',
      target: '_blank',
      view: 'blank'
    }
  },
  {
    path: '/front',
    name: '前端',
    meta: {
      renderMenu: false
    },
    component: () => import('@/components/layout/FrontView.vue'),
    children: [
      {
        path: '/login',
        name: '登录',
        meta: {
          icon: 'LoginOutlined',
          view: 'blank',
          target: '_blank',
          cacheable: false
        },
        component: () => import('@/pages/login')
      },
      {
        path: '/register',
        name: '注册',
        meta: {
          icon: 'LoginOutlined',
          view: 'blank',
          target: '_blank',
          cacheable: false
        },
        component: () => import('@/pages/register/Register.vue')
      },
      {
        path: '/home',
        name: '首页',
        meta: {
          view: 'blank'
        },
        component: () => import('@/pages/home')
      }
    ]
  },
  {
    path: '/403',
    name: '403',
    props: true,
    meta: {
      renderMenu: false
    },
    component: () => import('@/pages/Exp403.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    props: true,
    meta: {
      icon: 'CreditCardOutlined',
      renderMenu: false,
      cacheable: false,
      _is404Page: true
    },
    component: () => import('@/pages/Exp404.vue')
  },
  // {
  //   path: '/demo',
  //   name: 'demo',
  //   component: () => import('@/pages/Demo.vue')
  // },
  {
    path: '/client/turnover/:record',
    name: 'turnover',
    meta: {
      renderMenu: false,
      title: '客户流水'
    },
    component: () => import('@/pages/client/components/Turnover.vue')
  }
  // {
  //   path: '/pages/gift-manage',
  //   name: 'giftManage',
  //   meta: {
  //     renderMenu: false,
  //     title: ''
  //   },
  //   component: () => import('@/pages/giftManage/GiftManage.vue')
  // }
  // {
  //   path: '/role',
  //   name: 'role',
  //   meta: {
  //     renderMenu: true,
  //     title: '角色管理'
  //   },
  //   component: () => import('@/pages/role/Role.vue')
  // },
]

export default routes
